import styled from 'styled-components';
import { Typography } from '@/components/UI/Typography/Typography.styles';
import { Button } from '@/components/UI/Button/Button';
import { ellipsisMultiline } from '@/styles/helpers';
import { AngleBackIcon, CloseIcon } from '@/components/UI/Icons/Icons';

export const ComplaintButton = styled(Button)`
  display: grid;
  grid-template-columns: 17px 1fr;
  grid-template-rows: 44px;
  align-items: center;
  gap: 10px;
  text-align: left;

  background: ${({ theme }) => theme.palette.primary.background};
  border-radius: 21px;
  padding: 30px 0;

  svg {
    justify-self: center;
  }

  @media (max-width: ${({ theme }) => theme.breakpoints.md}) {
    padding: 15px;
  }

  @media (hover: hover) {
    &:hover {
      p {
        color: ${({ theme }) => theme.palette.system.red};
      }

      svg path {
        fill: ${({ theme }) => theme.palette.system.red};
      }
    }
  }
`;

export const SkeletonItem = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 10px;
  height: 60px;
`;

export const ComplaintHead = styled.div`
  display: grid;
  grid-template-columns: auto 1fr auto;
  align-items: center;
  gap: 10px;
  height: fit-content;
  margin-bottom: 30px;

  @media (max-width: ${({ theme }) => theme.breakpoints.md}) {
    height: 60px;
    padding-top: 15px;
    margin-bottom: 10px;
  }
`;

export const ComplaintHeadButton = styled(Button).attrs({
  appearance: 'primaryText',
  hasPadding: false,
})`
  border: 0;
`;

export const ComplaintBackIcon = styled(AngleBackIcon).attrs(({ theme }) => ({
  fill: theme.palette.secondary.labels,
}))`
  height: 20px;
  width: 12px;

  @media (max-width: ${({ theme }) => theme.breakpoints.md}) {
    height: 18px;
    width: 10px;
  }
`;

export const ComplaintTitle = styled(Typography.Title).attrs({
  $variant: '4',
})`
  ${ellipsisMultiline(1)}

  @media(max-width: ${({ theme }) => theme.breakpoints.md}) {
    font-size: 16px;
    font-weight: 500;
    text-align: center;
  }
`;

export const ComplaintCloseIcon = styled(CloseIcon).attrs(({ theme }) => ({
  fill: theme.palette.secondary.labels,
}))`
  height: 20px;
  width: 20px;

  @media (max-width: ${({ theme }) => theme.breakpoints.md}) {
    height: 15px;
    width: 15px;
  }
`;

export const ComplaintSubmit = styled(Button).attrs({
  isFullWidth: true,
  borderRadius: 14,
})`
  margin: 30px 0 10px;

  @media (max-width: ${({ theme }) => theme.breakpoints.md}) {
    margin: 20px 0;
  }
`;

export const ComplaintError = styled(Typography.Body)`
  padding: 5px 0 0;
  font-size: 14px;
  color: ${({ theme }) => theme.palette.system.red};
`;

export const PopupContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 30px;
  padding: 40px 50px;
  @media (max-width: ${({ theme }) => theme.breakpoints.md}) {
    gap: 20px;
    padding: 25px 20px 20px;
  }
`;

export const PopupTextContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 20px;

  @media (max-width: ${({ theme }) => theme.breakpoints.md}) {
    gap: 10px;
  }
`;

export const PopupTitle = styled(Typography.Header).attrs({
  $variant: '3',
})`
  text-align: center;
`;

export const PopupDescription = styled(Typography.Title).attrs({
  $variant: '3',
})`
  font-size: 15px;
  text-align: center;
  color: ${({ theme }) => theme.palette.secondary.labels};
`;

export const PopupButton = styled(Button)`
  width: 100%;
  border-radius: 14px;
`;
